import { QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { RouterProvider } from "react-router";

import { ToastProvider } from "@/components/ui/Toast";
import { createQueryClient } from "@/lib/api/queryClient";
import { router } from "@/routes/router";

export function App() {
  // El cliente se crea una sola vez. Creándolo en el cuerpo del componente, un
  // re-render lo reemplazaría y tiraría la caché entera.
  const [queryClient] = useState(createQueryClient);

  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  );
}
